<button [styleSheetFile]="styleSheetFile" [printSectionId]="printSectionId" [printTitle]="printTitle"
    [printStyle]="printStyle" ngxPrint [useExistingCss]="useExistingCss" class="btn btn-primary b btn-sm">
    <span class="fas fa-print"></span>
    Print
</button>